import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import avatar from "../../assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I first started programming when I was 17 Years old, and I have been in love with it ever since 💖
              <br />
              <br />I am fluent in languages like
              <i>
                <b className="purple"> Python, C, C++, JavaScript, and Java. </b>
              </i>
              <br />
              <br />
              My field of interest's are &nbsp;
              <i>
                <b className="purple">Full-Stack Web Development, ui/ux, and Generative AI, Web Technologies, </b> 
              </i> &nbsp;
                with a passion for building impactful digital products.
              <br />
              <br />
              I apply my skills through &nbsp;
              <i>
                <b className="purple">internships </b> 
              </i> &nbsp;, and &nbsp;
              <i>
                <b className="purple">collaborative projects </b> 
              </i> &nbsp;, conducting workshops, and contributing to real-world projects.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={avatar} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/SUYAMBULINGAMM"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
